module.exports = __webpack_public_path__ + "img/product.0d6aba99.svg";